export default __webpack_public_path__ + "static/Group 1736-85b82550a12ddd68ac3749942907c3c9.png";